import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        value: localStorage.getItem('token') ?? '',
        isLoading: false,
        loader: false
    },
    reducers: {
        setSession: (state, action) => {
            state.value = action.payload;
            localStorage.setItem('token', action.payload);
        },
        clearSession: (state) => {
            state.value = '';
            localStorage.removeItem('token');
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setLoader: (state, action) => {
            state.loader = action.payload;
        }
    }
});

export const { setSession, clearSession, setIsLoading, setLoader } = sessionSlice.actions;

export default sessionSlice.reducer;
